import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GS1LayoutModule } from '@gs1france/gs1-components-library';
import { DocumentService } from '@services/document.service';
import { UnsubscribeComponent } from '../unsubscribe/unsubscribe.component';
import { take, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'footer-comp',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],

  imports: [RouterLink, TranslateModule, GS1LayoutModule, UnsubscribeComponent]
})
export class FooterComponent {
  private documentService = inject(DocumentService);

  CGU() {
    this.documentService
      .getCGU()
      .pipe(
        take(1),
        switchMap((doc) => this.documentService.downloadDocument(doc.idDoc)),
        take(1),
        catchError(() => of(null))
      )
      .subscribe();
  }

  PolitiqueConfidentialite() {
    this.documentService
      .getPolitiqueConfidentialite()
      .pipe(
        take(1),
        switchMap((doc) => this.documentService.downloadDocument(doc.idDoc)),
        take(1),
        catchError(() => of(null))
      )
      .subscribe();
  }
}
